import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { UPLOAD_CONS } from '@core/constants/UploadConstants';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { delay, retryWhen, tap } from 'rxjs/operators';
import { SHARE_DC } from '../constants/ShareDCURLs';
import { UploadQueueImpl } from './UploadQueueImpl';
import { UploadUtility } from './UploadUtil';
declare var require: any;
export class UploadSmallFile {

  protected http: any;
  protected router: any;
  protected universalService: any;
  static singleInstance: any;
  localStorageService: any;
  delay: any = 0;
  storageFullErrorAlreadyShown: boolean = false;
  totalRemainingBytes:any = 0;
  timeRemaining:any;
  listService: any;
  folderService: any;
  dcGroupCodePicker: any;
  uploadUtil: any;
  static uploadSmallFileRef : any;

  constructor(protected globalService) {
    this.initializeProperties()
  }

  initializeProperties() {
    this.http = this.globalService.getHttpClientRef();
    this.router = this.globalService.getRouterRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    // this.universalService.MarkNewObjArray = [];
    this.listService = this.globalService.getListServiceRef();
    this.uploadUtil = UploadUtility.getInstance(this.globalService);
    this.uploadUtil.uploadedObjectResponse = {};
    UploadSmallFile.uploadSmallFileRef = this;
  }

  public static getInstance(globalService): UploadSmallFile {
    if (this.singleInstance == null) {
      this.singleInstance = new UploadSmallFile(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

async startSmallFileUpload(file, queueIndex, isFolderFile,ffile,resolveFromQueue,uploadQueue) {
    await this.uploadUtil.getUploadUrlForMultiDc();
    let classRef = this;
    try {
      file.uploadStarted = true;
      file.preparingUpload = false;
      let hash;
      if (file.hash == undefined || file.hash.length != 32) {
        file.hasher = this.uploadUtil.getIncrementalChecksumUtilInstance(UploadSmallFile.uploadSmallFileRef);
        hash = await file.hasher.getFileHash(file, queueIndex,uploadQueue);
      } else {
        hash = file.hash
      }

      if (hash) {
        file.hash = hash;
        if (!file.unique) {
          file.unique = new Date().getMilliseconds() + file.hash;
        }
        await new Promise(async (resolve, reject) => {
          let fileMetadata = classRef.uploadUtil.getfileMetaData(file);
          let url = "";
          if(window.location.href.includes("sharedwithme") && this.universalService.allowUpload){
            url = SHARE_DC["DC_URLS"]["SMALL_FILE_UPLOAD"];
          }else{
            const serviceUrls = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME];
            const serviceUrl = this.universalService.isAlbumsView ? serviceUrls["boardUploadURL"]: serviceUrls["uploadURL"];
            url = serviceUrl + ENV_CONFIG.commonUrls["singleFileUpload"];
          }
         
          if (file["tfKey"]) {
            url = url + "?tfKey=" + file["tfKey"];
          }
          const formData = new FormData();
          const httpOptions = { observe: 'events', reportProgress: true }
          formData.append("metadataString", JSON.stringify(fileMetadata));
          formData.append("file", file);
          let smallFileUploadObservable = classRef.http.post(url, formData, httpOptions);
          classRef.smallFileUploadHandler(smallFileUploadObservable, file,isFolderFile,ffile, resolve,resolveFromQueue,uploadQueue,queueIndex);
        });
        return classRef.uploadUtil.uploadedObjectResponse;
      }
    }
    catch (error) {
      classRef.universalService.showToast(error, "error");
      file.isError = true;
      file.uploadStarted = false;
      file.preparingUpload = false;
    }
  }

  public smallFileUploadHandler(smallFileUploadObservable, file,isFolderFile,ffile, resolveStartSmallFileUpload,resolveFromQueue,uploadQueue,queueIndex) {
    let classRef = this
    if(!window.location.href.includes('enterprise/userprofile') && !isFolderFile){
      classRef.uploadUtil.fileProgressUI(file);
    }
    ffile.subscriber = smallFileUploadObservable.pipe(
      retryWhen(errors => errors.pipe(delay(UPLOAD_CONS.AUTORETRY_REQ_TIME_DELAY),
      tap(errorObj => { 
        file = classRef.uploadUtil.autoRetryReqConditions(errorObj, file) 
      })))
    ).subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              {
                if(!isFolderFile)
                  classRef.smallFileUploadProgress(event, file,uploadQueue,queueIndex);
                else{
                  classRef.updateFolderUploadProgress(event,ffile,queueIndex,file,uploadQueue)
                }
                
                break;
              }
            case HttpEventType.Response:
              {  
                if(!isFolderFile){
                  file.hideProgress = true;
                  file.uploadStarted = false;
                  file.preparingUpload = false;
                  file.alreadyExists = false;
                  file.retryCount = 0;
                }
                if (event.status == 201) {
                  file.isError = false;
                  file.uploadDone = true;
                  if(!isFolderFile){
                    file.objectKey = event.body.objectKey;
                    file.imageTranscodeUrl = classRef.uploadUtil.populateThumbnailUrlPostUpload(event.body?.imageTranscodeUrl,event.body?.mimeType,event.body?.mimeSubType,file?.locationOfUpload)
                    if(file["boardKey"]){
                      file["objectMetadata"] = event.body
                    }
                    classRef.uploadUtil.emitUploadedObject(event.body);
                  }
                } else {
                  file.isError = true;
                  file.progress = 0;
                  file.uploadDone = false;
                }
                classRef.uploadUtil.setUploadResponseOfCurrentlyUploadedFileInObject("success",event.body);
                resolveStartSmallFileUpload();
                return;
              }
          }
        },
        (error: HttpErrorResponse) => {
          let item = file;
          if(isFolderFile)
            item = ffile
          if(!isFolderFile)
            return classRef.uploadUtil.handleHttpError(error, item, resolveStartSmallFileUpload,resolveFromQueue);
          else{
            classRef.uploadUtil.setUploadResponseOfCurrentlyUploadedFileInObject("error",error);
            resolveStartSmallFileUpload();
        }
    });
  }
  
  smallUploadRateArray:any = [];
  updateFolderUploadProgress(event,ffile,queueIndex,file,uploadQueue){
    let tempArray = [];
    let time = new Date().getTime()
    this.totalRemainingBytes = this.uploadUtil.getRemainingBytes(uploadQueue,queueIndex)

    let totalRemainingBytes = this.totalRemainingBytes ;
    if(uploadQueue[queueIndex].uploadSmallByteMap.get(file.hash)!=undefined)
     tempArray = uploadQueue[queueIndex].uploadSmallByteMap.get(file.hash);
    if (tempArray.length >= 1 && (time - tempArray[tempArray.length - 1]['time']) < UPLOAD_CONS.ESTIMATED_SMF_TIME_CALC_DELAY) 
      return;
    
    tempArray.push({
      'bytes':event.loaded,
      'time': time,
      'remainingBytes': totalRemainingBytes,
  
    });
  
     uploadQueue[queueIndex].uploadSmallByteMap.set(file.hash,tempArray)
    
    if(tempArray.length>1){
      let arrayLength =  tempArray.length;
      if(tempArray[arrayLength - 1]['bytes']<=tempArray[arrayLength - 2]['bytes'])
        return;
      if(tempArray[arrayLength - 1]['time']<=tempArray[arrayLength - 2]['time'])
        return;
      let uploadRate = (tempArray[arrayLength - 1]['bytes'] - tempArray[arrayLength - 2]['bytes']) / (tempArray[arrayLength - 1]['time'] - tempArray[arrayLength - 2]['time']);

      if (uploadRate < 99) {
        return;
      }
       /* temp commented*/
      let totalUploadRate = 0;
      let smallUploadRateArrayLength = this.smallUploadRateArray.length;
      let avgLoadRate=0;
      let smallLoadRate = 0;
      let largeLoadRate = 0;
      if(smallUploadRateArrayLength > 2){
        if(this.smallUploadRateArray[0] > this.smallUploadRateArray[1]){
          smallLoadRate = this.smallUploadRateArray[1]; 
          largeLoadRate = this.smallUploadRateArray[0];
        }else{
          smallLoadRate = this.smallUploadRateArray[0]; 
          largeLoadRate = this.smallUploadRateArray[1];
        }
        for(let pos=2;pos<smallUploadRateArrayLength;pos++){
          if(this.smallUploadRateArray[pos] <= smallLoadRate){
            smallLoadRate = this.smallUploadRateArray[pos];
          }else if(this.smallUploadRateArray[pos] >= largeLoadRate){
            largeLoadRate = this.smallUploadRateArray[pos];
          } 
        }
        if(uploadRate<smallLoadRate || uploadRate > (largeLoadRate*2))
          return;
        else
          avgLoadRate = (smallLoadRate+largeLoadRate)/2;
      }else if(smallUploadRateArrayLength > 0){
        this.smallUploadRateArray.forEach(obj => {
          totalUploadRate=totalUploadRate+obj;
        });
        avgLoadRate = totalUploadRate/smallUploadRateArrayLength;
      }
  
      if(avgLoadRate<99 && (smallLoadRate>0 || largeLoadRate>0))
        return;
  
     
      this.smallUploadRateArray.push(uploadRate)
      
      ffile.lastUploadRate = uploadRate;
      UploadQueueImpl.commonSmallFileUploadRate = uploadRate;
  
      if(this.smallUploadRateArray.length>5){
        this.smallUploadRateArray.shift();
      } 
      let leftReadingtime = 0;
      let totalRemainingReadingBytes = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
      let pendingUploadSmallBytes = this.uploadUtil.getRemainingSmallFileSizeUpload(uploadQueue);
      let pendingUploadLargeBytes = this.uploadUtil.getRemainingLargeFileSizeUpload(uploadQueue);
      let pendingtime=0
        if(UploadQueueImpl.commonReadRate > 0 && totalRemainingReadingBytes>0 )
          pendingtime = totalRemainingReadingBytes/(UploadQueueImpl.commonReadRate*1000) 
        if(UploadQueueImpl.commonLargeFileUploadRate>0 && pendingUploadLargeBytes>0)
          pendingtime =  pendingtime + pendingUploadLargeBytes/(UploadQueueImpl.commonLargeFileUploadRate*1000);
        if(UploadQueueImpl.commonSmallFileUploadRate>0 && pendingUploadSmallBytes>0)
          pendingtime =  pendingtime + pendingUploadSmallBytes/(UploadQueueImpl.commonSmallFileUploadRate*1000);
     this.timeRemaining = pendingtime;
      this.getEstimatedUploadTimeString_Folder(uploadRate,"",false,uploadQueue);
    
    }else{
      if(UploadQueueImpl.timeLeftToFinishUpload == "") 
        UploadQueueImpl.timeLeftToFinishUpload = "Started Uploading..";
    }
  }

  public smallFileUploadProgress(evt, file,uploadQueue,queueIndex) { 
    let classRef=this;
    if (uploadQueue.findIndex(function(obj) {
        return obj.hash == file.hash
      }) == 0 && file.progress < 25 && (UploadQueueImpl.commonSmallFileUploadRate+UploadQueueImpl.commonLargeFileUploadRate)/2 <= 0 && UploadQueueImpl.timeLeftToFinishUpload == "") {
        UploadQueueImpl.timeLeftToFinishUpload = "Started Uploading..";
    }
    classRef.totalRemainingBytes = classRef.uploadUtil.getRemainingBytes(uploadQueue,queueIndex);
    
    if (file.uploadByteTimeArray.length > 2) {
      file.uploadByteTimeArray.shift();
    }
    if (evt.type=1) {
      let uploadBytesCount = evt.loaded;
      if (evt.loaded == evt.total) {
        file.uploadedBytes =  evt.total;
        uploadBytesCount = 0;
        classRef.totalRemainingBytes = classRef.totalRemainingBytes - file.size;
        file.uploadByteTimeArray = [];
        if(this.uploadUtil.isLastFileToUpload(uploadQueue).length > 0) 
          classRef.getPendingTime(uploadQueue);
      } else {
        let time = new Date().getTime();
        if (file.uploadByteTimeArray.length >= 1 && (time - file.uploadByteTimeArray[file.uploadByteTimeArray.length - 1]['time']) < UPLOAD_CONS.ESTIMATED_SMF_TIME_CALC_DELAY) {
          // Reading bytes atleast after 2 seconds of reading previous one, else skip")
          return;
        }
        else {
          file.uploadByteTimeArray.push({
            'bytes': evt.loaded,
            'time': time,
            'remainingBytes': classRef.totalRemainingBytes - evt.loaded
          });
          classRef.getSmallFileUploadRate(file,uploadQueue);
        }
      }

      file.progress = Math.round(evt.loaded * 100 / evt.total);
      if(file.circle){
        file.circle.set(evt.loaded / evt.total);
      }

    } else {
     // file.progress = 'in progress';
    }
  }
    
  protected getPendingTime(uploadQueue) { 
    let classRef = this;
    let readingBytes = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
    let pendingUploadSmallBytes = this.uploadUtil.getRemainingSmallFileSizeUpload(uploadQueue);
    let pendingUploadLargeBytes = this.uploadUtil.getRemainingLargeFileSizeUpload(uploadQueue);
    

    let avgLoadRate = (UploadQueueImpl.commonSmallFileUploadRate+UploadQueueImpl.commonLargeFileUploadRate)/2;
    
    let pendingtime=0
    if(UploadQueueImpl.commonReadRate > 0 && readingBytes>0 )
      pendingtime = readingBytes/(UploadQueueImpl.commonReadRate*1000) 
    if(UploadQueueImpl.commonLargeFileUploadRate>0 && pendingUploadLargeBytes>0)
      pendingtime =  pendingtime + pendingUploadLargeBytes/(UploadQueueImpl.commonLargeFileUploadRate*1000);
    if(UploadQueueImpl.commonSmallFileUploadRate>0 && pendingUploadSmallBytes>0)
      pendingtime =  pendingtime + pendingUploadSmallBytes/(UploadQueueImpl.commonSmallFileUploadRate*1000);
    
    this.timeRemaining = pendingtime;
    
    if(UploadQueueImpl.timeLeftToFinishUpload == ""){
      UploadQueueImpl.timeLeftToFinishUpload = "Starting Upload.."; 
      return;
    }else if (classRef.timeRemaining == "Infinity" || classRef.timeRemaining <= 0) {
      return;
    }

    if (avgLoadRate == 0 || avgLoadRate < 0) {
      return;
    }
    let timeRemainingInSec = classRef.timeRemaining
    let dataDetails = this.uploadUtil.isLastFileToUpload(uploadQueue);
    if ( dataDetails.length == 1 && ( this.timeRemaining<5 || dataDetails[0].progress >80 ))  { 
      UploadQueueImpl.timeLeftToFinishUpload = `Finishing upload..`
    }else if (timeRemainingInSec >= 5 && timeRemainingInSec < 60) {
      UploadQueueImpl.timeLeftToFinishUpload = "Less than a minute left (" + Math.round(timeRemainingInSec) + " seconds)";
    } else if (timeRemainingInSec >= 60) {
      let timeRemainingInMin = timeRemainingInSec /60 ;
      if(timeRemainingInMin>60){
        let hour = timeRemainingInMin/60;
        let min = timeRemainingInMin%60;
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(hour)} hour & ${Math.round(min)} min left..`;
      }else{
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(timeRemainingInMin)} min left..`;
      }
    } 
  }

  private getSmallFileUploadRate(file,uploadQueue) {

    let classRef = this;
    var arrayLength = file.uploadByteTimeArray.length;
    if (file.uploadByteTimeArray.length > 1) {
      var uploadRate = (file.uploadByteTimeArray[arrayLength - 1]['bytes'] - file.uploadByteTimeArray[arrayLength - 2]['bytes']) /
        (file.uploadByteTimeArray[arrayLength - 1]['time'] - file.uploadByteTimeArray[arrayLength - 2]['time']);

      if (uploadRate < 99) {
        return;
      }
      let totalUploadRate = 0;

       /* get smalluploadrate & largeuploadrate*/
    let smallUploadRateArrayLength = this.smallUploadRateArray.length;
    //let tempuploadRate = uploadRate;
    let avgLoadRate=0;
    let smallLoadRate = 0;
    let largeLoadRate = 0;
    if(smallUploadRateArrayLength > 2){
      if(this.smallUploadRateArray[0] > this.smallUploadRateArray[1]){
        smallLoadRate = this.smallUploadRateArray[1]; 
        largeLoadRate = this.smallUploadRateArray[0];
      }else{
        smallLoadRate = this.smallUploadRateArray[0]; 
        largeLoadRate = this.smallUploadRateArray[1];
      }
      for(let pos=2;pos<smallUploadRateArrayLength;pos++){
        if(this.smallUploadRateArray[pos] <= smallLoadRate){
          smallLoadRate = this.smallUploadRateArray[pos];
        }else if(this.smallUploadRateArray[pos] >= largeLoadRate){
          largeLoadRate = this.smallUploadRateArray[pos];
        } 
      }
      if(uploadRate<smallLoadRate || uploadRate > (largeLoadRate*2))
        return;
      else
        avgLoadRate = (smallLoadRate+largeLoadRate)/2;
    }else if(smallUploadRateArrayLength > 0){
      this.smallUploadRateArray.forEach(obj => {
        totalUploadRate+=obj;
      });
      avgLoadRate = totalUploadRate/smallUploadRateArrayLength;
    }

    if(avgLoadRate<99 && (smallLoadRate>0 || largeLoadRate>0))
      return;

    this.smallUploadRateArray.push(uploadRate)
    
    file.lastUploadRate = uploadRate;
    UploadQueueImpl.commonSmallFileUploadRate = uploadRate;
    
    if(this.smallUploadRateArray.length>5){
      this.smallUploadRateArray.shift();
    } 
      
      if (classRef.uploadUtil.isSingleUploadOn(uploadQueue)) {
        //In case of single Small File upload, directly getting small file total time
        classRef.getTotalTime(file.uploadByteTimeArray[arrayLength - 1]['remainingBytes'], uploadRate, file,uploadQueue);
      }
      else {
        //In case of multiple File upload,checking if any file started uploading & showing the time remaining;
        file.timeToUpload = file.uploadByteTimeArray[arrayLength - 1]['remainingBytes'] / uploadRate;
        this.getMultipleUploadTotalTime(uploadRate, false, file,uploadQueue)
      }

    }
  }

  public getEstimatedUploadTimeString_Folder(rate, file, isSingleFileUpload: boolean,uploadQueue) {
    let timeRemainingInSec = this.timeRemaining ;
    if (this.timeRemaining == "Infinity" || this.timeRemaining <= 0) {
      UploadQueueImpl.timeLeftToFinishUpload = 'Started Uploading..' 
      return;
    }
    if (0 < timeRemainingInSec && timeRemainingInSec < 1) {
      timeRemainingInSec = 2;
    }
    let dataDetails = this.uploadUtil.isLastFileToUpload(uploadQueue);
    if ( dataDetails.length == 1 && (this.timeRemaining<8 || dataDetails[0].progress >90)) { 
      UploadQueueImpl.timeLeftToFinishUpload = `Finishing upload..`
    }else if (timeRemainingInSec >= 8 && timeRemainingInSec < 60) {
      UploadQueueImpl.timeLeftToFinishUpload = "Less than a minute left (" + Math.round(timeRemainingInSec) + " seconds)";
    }
    else if (timeRemainingInSec >= 60) {
      let timeRemainingInMin = Math.round(timeRemainingInSec / 60);
      if(timeRemainingInMin>60){
        let hour = timeRemainingInMin/60;
        let min = timeRemainingInMin%60;
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(hour)} hour & ${Math.round(min)} min left..`;
      }else{
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(timeRemainingInMin)} min left..`;
      }

    }
    
  }

  private getTotalTime(remainingBytes, uploadRate, file,uploadQueue) {
    let classRef = this;
    let readingBytes = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
    let pendingUploadSmallBytes = this.uploadUtil.getRemainingSmallFileSizeUpload(uploadQueue);
    let pendingUploadLargeBytes = this.uploadUtil.getRemainingLargeFileSizeUpload(uploadQueue);
    let pendingtime=0
    if(UploadQueueImpl.commonReadRate > 0 && readingBytes>0 )
      pendingtime = readingBytes/(UploadQueueImpl.commonReadRate*1000) 
    if(UploadQueueImpl.commonLargeFileUploadRate>0 && pendingUploadLargeBytes>0)
      pendingtime =  pendingtime + pendingUploadLargeBytes/(UploadQueueImpl.commonLargeFileUploadRate*1000);
    if(UploadQueueImpl.commonSmallFileUploadRate>0 && pendingUploadSmallBytes>0)
      pendingtime =  pendingtime + pendingUploadSmallBytes/(UploadQueueImpl.commonSmallFileUploadRate*1000);
    this.timeRemaining  =  pendingtime;
    
    if (classRef.timeRemaining == "Infinity" || classRef.timeRemaining <= 0) {
      return;
    }

    if (uploadRate == 0 || uploadRate < 0) {
      return;
    }
    if ( classRef.uploadUtil.isLastFileToUpload(uploadQueue).length == 1 && file.progress > 80) {
      UploadQueueImpl.timeLeftToFinishUpload = "Finishing upload.."
    }else if (classRef.timeRemaining >= 5 && classRef.timeRemaining < 60) {
      UploadQueueImpl.timeLeftToFinishUpload = "Less than a minute left (" + Math.round(classRef.timeRemaining) + " seconds)";
    } else if (classRef.timeRemaining >= 60) {
      let timeRemainingInMin = classRef.timeRemaining /60 ;
      if(timeRemainingInMin>60){
        let hour = timeRemainingInMin/60;
        let min = timeRemainingInMin%60;
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(hour)} hour & ${Math.round(min)} min left..`;
      }else{
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(timeRemainingInMin)} min left..`;
      }
    }
  }

  public getMultipleUploadTotalTime(rate, isReading, file,uploadQueue) {
    let readingSize = this.uploadUtil.getRemainingLargeFileSizeRead(uploadQueue);
    if(isReading && (UploadQueueImpl.commonSmallFileUploadRate+UploadQueueImpl.commonLargeFileUploadRate)<=0){
      let readingTime = readingSize / rate // pending time remaing for comple
      this.timeRemaining = readingTime/1000;
      this.getEstimatedReadTimeString(rate)
    }else{
      let classRef = this;
      let pendingUploadSmallBytes = this.uploadUtil.getRemainingSmallFileSizeUpload(uploadQueue);
      let pendingUploadLargeBytes = this.uploadUtil.getRemainingLargeFileSizeUpload(uploadQueue);
      
  
      let avgLoadRate = (UploadQueueImpl.commonSmallFileUploadRate + UploadQueueImpl.commonLargeFileUploadRate)/2;
      let pendingtime = 0;
      if(UploadQueueImpl.commonReadRate > 0 && readingSize>0 )
        pendingtime = readingSize/(UploadQueueImpl.commonReadRate*1000) 
      if(UploadQueueImpl.commonLargeFileUploadRate>0 && pendingUploadLargeBytes>0)
        pendingtime =  pendingtime + pendingUploadLargeBytes/(UploadQueueImpl.commonLargeFileUploadRate*1000);
      if(UploadQueueImpl.commonSmallFileUploadRate>0 && pendingUploadSmallBytes>0)
        pendingtime =  pendingtime + pendingUploadSmallBytes/(UploadQueueImpl.commonSmallFileUploadRate*1000);
      
      this.timeRemaining = pendingtime;
      
      pendingUploadSmallBytes
      
      if (classRef.timeRemaining == "Infinity" || classRef.timeRemaining <= 0) {
        return;
      }
      let remainingdata = pendingUploadSmallBytes+pendingUploadLargeBytes

      this.getEstimatedUploadTimeString(avgLoadRate, file, false,uploadQueue,remainingdata); // getting estimated Upload time Message;


    }
  }

  public getEstimatedUploadTimeString(rate, file, isSingleFileUpload: boolean,uploadQueue,remainingdata) {
    if ((rate == 0 || rate < 0) || (this.timeRemaining == "Infinity" || this.timeRemaining <= 0)) {
      UploadQueueImpl.timeLeftToFinishUpload = `Started Uploading..`// }
      return;
    }
    if ( this.uploadUtil.isLastFileToUpload(uploadQueue).length == 1 && ( this.timeRemaining<5 || remainingdata<2000 || this.uploadUtil.isLastFileToUpload(uploadQueue)[0].progress > 80)) {//else if  ((this.timeRemaining <= 10 || file.progress > 95) && this.uploadUtil.isLastFileToUpload()) { 
      UploadQueueImpl.timeLeftToFinishUpload = `Finishing upload..`
    }else if (this.timeRemaining >= 5 && this.timeRemaining < 60) {
      UploadQueueImpl.timeLeftToFinishUpload = "Less than a minute left (" + Math.round(this.timeRemaining) + " seconds)";
    }
    else if (this.timeRemaining >= 60) {
      let timeRemainingInMin = this.timeRemaining/60;
      if(timeRemainingInMin>60){
        let hour = timeRemainingInMin/60;
        let min = timeRemainingInMin%60;
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(hour)} hour & ${Math.round(min)} min left..`;
      }else{
        UploadQueueImpl.timeLeftToFinishUpload = `${Math.round(timeRemainingInMin)} min left..`;
      }
    }
  }

  public getEstimatedReadTimeString(rate) {
    if ((this.timeRemaining > 0 && this.timeRemaining <= 3) || !rate) {
      UploadQueueImpl.timeLeftToFinishUpload = `Started Uploading..`
      return;
    }
    else if ((rate == 0 || rate < 0) || (this.timeRemaining == "Infinity" || this.timeRemaining <= 0)) {
      return;
    }
    else if (this.timeRemaining < 60 && this.timeRemaining > 1 &&  UploadQueueImpl.timeLeftToFinishUpload == "") {
      UploadQueueImpl.timeLeftToFinishUpload = `Initializing upload in less than a min (${Math.round(this.timeRemaining)} seconds)`;
    }
    else if (this.timeRemaining > 60 &&  UploadQueueImpl.timeLeftToFinishUpload == "") {
      this.timeRemaining = Math.round(this.timeRemaining / 60 );
      UploadQueueImpl.timeLeftToFinishUpload = `Initializing upload  in ${this.timeRemaining} min`;
    }
  }
}